// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Календар» (Calendar, ключ `cal`, група `management`). */
export const calendarManifest: IModuleManifest = {
  key: 'cal',
  group: 'management',
  slug: 'calendar',
  prefix: 'CAL',
  name: { en: 'Calendar', uk: 'Календар' },
  entities: [
    { key: 'cal', slug: 'cal', name: { en: 'Calendar', uk: 'Календар' }, main: true },
    { key: 'event_participant', slug: 'event-participant', name: { en: 'Event Participants', uk: 'Учасники' }, main: false },
    { key: 'event_room', slug: 'event-room', name: { en: 'Event Rooms', uk: 'Приміщення' }, main: false },
  ],
  loadState: () => import('./state/calendarSlice').then((m) => m.calendarSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
